import { Flex, Heading, Text, Stack } from "@chakra-ui/react";
import { ReactElement, useContext } from "react";
import React from "react";
import { LanguageContext } from "../components/LanguageProvider";
import { messages } from "../intl/config"; // Import dostępnych tłumaczeń
import {
  IoSearchOutline,
  IoBodyOutline,
  IoTimeOutline,
  IoConstructOutline,
} from "react-icons/io5";

interface ItemProps {
  icon: ReactElement;
  title: string;
  text: string;
}

const Item = ({ icon, title, text }: ItemProps) => {
  return (
    <Stack direction={"row"} align={"center"} spacing={4}>
      <Flex
        p={2}
        align={"center"}
        justify={"center"}
        rounded={"full"}
        alignSelf={"flex-start"}
        bg={"purple.50"}
        marginTop={0.5}
      >
        {icon}
      </Flex>
      <Stack spacing={0} w={"full"}>
        <Heading marginTop={0} fontSize={"xl"}>
          {title}
        </Heading>
        <Text color={"gray.600"}>{text}</Text>
      </Stack>
    </Stack>
  );
};

function ProblemStatement() {
  const { locale = "en" } = useContext(LanguageContext); // Pobieramy aktualny język
  const translations = messages[locale] || {}; // Wybieramy tłumaczenia na podstawie języka

  const items = [
    {
      icon: <IoBodyOutline fontSize="1.5rem" />,
      title: translations["problemStatement.items.0.title"],
      text: translations["problemStatement.items.0.text"],
    },
    {
      icon: <IoSearchOutline fontSize="1.5rem" />,
      title: translations["problemStatement.items.1.title"],
      text: translations["problemStatement.items.1.text"],
    },
    {
      icon: <IoTimeOutline fontSize="1.5rem" />,
      title: translations["problemStatement.items.2.title"],
      text: translations["problemStatement.items.2.text"],
    },
    {
      icon: <IoConstructOutline fontSize="1.5rem" />,
      title: translations["problemStatement.items.3.title"],
      text: translations["problemStatement.items.3.text"],
    },
  ];

  return (
    <Stack flex={1} spacing={{ base: 5, md: 20 }} px={4} py={8}>
      {items.map((item, index) => (
        <Item key={index} icon={item.icon} title={item.title} text={item.text} />
      ))}
    </Stack>
  );
}

export default ProblemStatement;
